/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Core
import styled from 'styled-components';

// Libraries
import { ToastContainer } from 'react-toastify';
import { Trans } from 'react-i18next';

// Plugins
import { hexToRgba } from '../../../plugins/general';

export const ToastElement = styled(ToastContainer)`
  width: 100dvw;
  max-width: 100dvw;
  margin: 0;
  padding: 0;
  
  &.Toastify__toast-container {
    padding: 8px;
    max-width: 100%;
    gap: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    
    > .Toastify__toast {
      height: auto;
      min-height: 2.375rem;
      max-width: max-content;
      margin: 0;
      padding: 0;
      font-family: ${({ theme }) => theme.font.regular};
      border-radius: 0.375rem;
      display: flex;
      align-items: center;
      box-shadow: 0 0.125rem 0.5rem -0.125rem ${({
        theme,
      }) => hexToRgba(theme.color.toast.shadowColor, 0.5)},
      0 0.5rem 1.75rem -0.25rem ${({ theme }) => hexToRgba(theme.color.toast.shadowColor, 0.1)};
    };
  };

  .Toastify__toast-body {
    padding: 0.5rem 0.75rem;
    gap: 0.5rem;
    line-height: 1.375rem;
    font-size: 0.875rem;
    letter-spacing: -0.018rem;
    color: ${({ theme }) => theme.color.toast.textColor};
  };

  .Toastify__toast-icon {
    margin-inline-end: unset;
  };
  
  .Toastify__toast--loading > .Toastify__toast-body > .Toastify__toast-icon > svg {
    animation: rotation 2s infinite linear;
    color: ${({ theme }) => theme.color.toast.loadingIconColor};

    @keyframes rotation {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    };
  };
  
  .Toastify__toast--success > .Toastify__toast-body > .Toastify__toast-icon > svg,
  .Toastify__toast--error > .Toastify__toast-body > .Toastify__toast-icon > svg {
    animation: none;
  };
`;

export const TextMessage = styled(Trans)`
  font-family: ${({ theme }) => theme.font.regular};
  > strong {
    font-family: ${({ theme }) => theme.font.bold};
  };
`;
